var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfServicePortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8H34.5C36.7091 8 38.5 9.79086 38.5 12V20C38.5 21.8638 37.2252 23.4299 35.5 23.874V25.917C38.3377 25.441 40.5 22.973 40.5 20V12C40.5 8.68629 37.8137 6 34.5 6H14.5C11.1863 6 8.5 8.68629 8.5 12V20C8.5 22.973 10.6623 25.441 13.5 25.917V23.874C11.7748 23.4299 10.5 21.8638 10.5 20V12C10.5 9.79086 12.2909 8 14.5 8Z",
    fill: "#6092DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 29.25V18.9995C20.5 18.4514 19.6222 18 18.5449 18H18.4551C17.3778 18 16.5 18.4433 16.5 18.9995V33",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27V24.5597C24.5 23.7003 23.6 23 22.5 23C21.4 23 20.5 23.7003 20.5 24.5597V27",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C16.5 36.9726 20.0869 41 24.5 41C28.9131 41 32.5 36.9726 32.5 32",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29V26.5597C28.5 25.7003 27.6 25 26.5 25C25.4 25 24.5 25.7003 24.5 26.5597V29",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 33V27.3647C32.5 26.6127 31.6 26 30.5 26C29.4 26 28.5 26.6127 28.5 27.3647",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfServicePortal);
export default __webpack_public_path__ + "static/media/self-service-portal.258fac24.svg";
export { ForwardRef as ReactComponent };